/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Theme_Switch_LightInputs */

const en_theme_switch_light = /** @type {(inputs: Theme_Switch_LightInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Switch to the light theme`)
};

/**
* | output |
* | --- |
* | "Switch to the light theme" |
*
* @param {Theme_Switch_LightInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const theme_switch_light = /** @type {((inputs?: Theme_Switch_LightInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Theme_Switch_LightInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_theme_switch_light(inputs)
});